export enum EObjectType {
  Flat = 'flat',
  Room = 'room',
  Land = 'land',
  House = 'house',
}

export const OBJECT_TYPES = [
  {
    name: 'Квартира',
    value: EObjectType.Flat,
  },
  {
    name: 'Комната',
    value: EObjectType.Room,
  },
  {
    name: 'Участок',
    value: EObjectType.Land,
  },
  {
    name: 'Участок и дом',
    value: EObjectType.House,
  },
];
